import * as types from 'legacy/src/constants/types';
import { isImpersonatingSubjectAvailable } from 'legacy/src/components/impersonating/utils';
import isSubjectAvailable from 'legacy/src/components/impersonating/utils/isSubjectAvailable';
import {
  IMPERSONATING_TELEMETRY_TYPES,
  LC_CONSTANTS,
  SUBJECT_RESTRICTION_TYPES,
} from 'legacy/src/components/impersonating/utils/constants';
import postImpersonatingTelemetryData from '../utils/telemetry';
/**
 * @params {object} impersonating redux reducer
 * @params {array} studentSubjects The list of subjects the student is seeing in subject selector
 * @params {boolean} apImpersonatingFlag
 * @params {boolean} preapImpersonatingFlag
 * @params {function} onRestrictedSubject
 * */
const useSubjectRestrictions = (props) => {
  const {
    impersonating,
    studentSubjects,
    apImpersonatingFlag,
    preapImpersonatingFlag,
    onRestrictedSubject = () => {},
    userData,
  } = props;
  const { teacherSubjects, studentId, educationPeriod, teacherClasses } =
    impersonating;

  const stopSubjectSelection = (event, messageType) => {
    event.preventDefault();
    onRestrictedSubject(messageType);
  };

  const setSubjectRestrictions = (event, subjectId) => {
    const studentSubject = studentSubjects.find(({ id }) => id === subjectId);
    const { subjectProgram } = studentSubject;

    if (
      !isImpersonatingSubjectAvailable({
        program: subjectProgram,
        apImpersonatingFlag,
        preapImpersonatingFlag,
      })
    ) {
      const messageType =
        subjectProgram === types.AP
          ? SUBJECT_RESTRICTION_TYPES.PROGRAM_AP
          : SUBJECT_RESTRICTION_TYPES.PROGRAM_PREAP;
      stopSubjectSelection(event, messageType);
    } else {
      const isTeacherTeaching = isSubjectAvailable({
        subjectId,
        studentId,
        educationPeriod,
        teacherSubjects,
      });
      if (!isTeacherTeaching) {
        stopSubjectSelection(event, SUBJECT_RESTRICTION_TYPES.NOT_TEACHING);
      } else {
        // send a start event for subject change
        const startImpersonatedTelData = {
          eventType: IMPERSONATING_TELEMETRY_TYPES.START,
          sectionId: window.localStorage.getItem(LC_CONSTANTS.SECTION_ID),
          studentId,
          subjectId,
          userData,
          teacherClasses,
        };
        postImpersonatingTelemetryData(startImpersonatedTelData);
      }
    }
  };

  return [{}, setSubjectRestrictions];
};

export default useSubjectRestrictions;
